export default __webpack_public_path__ + "static/media/Connecticut4.eb675f36.png";